import {makeStyles} from '@material-ui/core/styles';
import {Theme} from './Theme';

export class Styles {
    static readonly loading:any = makeStyles( {
        paper: {
            position:"absolute",
            top:"0",
            left:"0",
            width:"100%",
            height:"100%",
            backgroundColor:"white",
            opacity:0.7,
            boxSizing:"border-box",
        },
        spinner: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
        },
    });
    static readonly base:any = makeStyles( {
        root: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"4em",
            overflow:"hidden",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "0",
                paddingLeft: "0",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        mainRoot: {
            height:"100%",
            boxSizing:"border-box",
            paddingTop:"4em",
            overflow:"hidden",
        },
        modalRoot: {
            height:"100%",
            boxSizing:"border-box",
            overflow:"hidden",
            [Theme.breakpoints.down('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
            [Theme.breakpoints.up('md')]: {
                paddingRight: "1em",
                paddingLeft: "1em",
            },
        },
        App: {
            width:"100%",
            height:"100%",
            maxWidth:"480px",
            maxHeight:"640px",
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
            boxSizing:"border-box",
            boxShadow:"0px 0px 2px 1px #E5E5E5",
            backgroundColor: Theme.palette.primary.contrastText,
            overflow:"hidden",
            //backgroundColor: "#D8F2DA",
        },
        AppBar: {
            padding:"0.5em 0",
            color: Theme.palette.primary.contrastText,
            fontWeight:"bold",
        },
        Toolbar: {
            padding:"0 1em",
        },
        grow: {
            flexGrow: 1,
        },        
        fabAddHaiku: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"auto",
            right:"1em",
            //transform : "translate(-50%,0%)",
            //webkitTransform : "translate(-50%,0%)",
            //msTransform : "translate(-50%,0%)",
            color:Theme.palette.primary.contrastText,
        },
        fabClose: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"50%",
            right:"auto",
            transform : "translate(-50%,0%)",
            webkitTransform : "translate(-50%,0%)",
            msTransform : "translate(-50%,0%)",
            color:Theme.palette.primary.contrastText,
        },
        test: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"1em",
            right:"auto",
            color:Theme.palette.primary.contrastText,
        },
        primary: {
            color: Theme.palette.primary.main,
        },
        primaryText: {
            color: Theme.palette.primary.contrastText,
        },
        secondary: {
            color: Theme.palette.secondary.main,
        },
        link: {
            color: Theme.palette.secondary.dark,
        },
        choiced: {
            position:"relative",
            padding:"2em 1em",
            minHeight:"7em",
            marginBottom:"1em",
            //backgroundColor: "#D8F2DA",
        },
        panel : {
            position:"relative",
            padding:"2em 1em",
            minHeight:"7em",
            marginBottom:"1em",
            //backgroundColor: "#D8F2DA",
        },
        haikuChoiceButton: {
            width:"100%",
            //backgroundColor:"white",
            marginBottom:"0.5em",
            //color:"#ffffff",
        },
        upperButtons: {
            textAlign: "center",
        },
        lowerButtons: {
            textAlign: "center",
            marginTop: "1em",
        },
        yes: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"auto",
            right:"1em",
            color:Theme.palette.primary.contrastText,
        },
        no: {
            position:"absolute",
            top:"auto",
            bottom:"1em",
            left:"1em",
            right:"auto",
            color:Theme.palette.primary.contrastText,
        },
        guide: {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform : "translate(-50%,-50%)",
            webkitTransform : "translate(-50%,-50%)",
            msTransform : "translate(-50%,-50%)",
        },
        timeline: {
            padding:"1em",
            //paddingTop:"5em",
            height:"100%",
            overflowY:"auto",
            boxSizing:"border-box",
        },
        songBox: {
            position:"relative",
            marginBottom:"2em",
        },
        songStatus: {
            position:"absolute",
            top:"50%",
            left:"0",
            transform : "translate(0%,-50%)",
            webkitTransform : "translate(0%,-50%)",
            msTransform : "translate(0%,-50%)",
            width:"3em",
            color:Theme.palette.primary.main,
        },
        songLines: {
            marginLeft:"4em",
            //marginBottom:"0.5em",
        },
        modal: {
            position:"absolute",
            width:"94%",
            height:"94%",
            maxWidth:"460px",
            maxHeight:"620px",
            backgroundColor:"#FFFFFF",
            boxSizing:"border-box",
        },
        withIcon: {
            display:"inline-flex",
            verticalAlign:"middle",
        },
        modalHead: {
            //height:"2em",
            paddingTop:"0.3em",
            paddingLeft:"0",
            backgroundColor:Theme.palette.primary.main,
        },
        haiku: {
            color:Theme.palette.primary.main,
        },
        newline: {
            color:Theme.palette.secondary.main,
        },
        iconStar: {

        },
        iconStarChecked: {
            color: Theme.palette.error.main,
        }
   });
}